export default {
  SERIF: 'serif',
  SANS_SERIF: 'sans-serif',
  MONOSPACE: 'monospace',
  DISPLAY: 'display',
  HANDWRITING: 'handwriting',
};
